import React from 'react';
import { Link } from 'react-router-dom';
import servicioResidencial from '../assets/services/servicio-residencial-373x200.png';
import servicioComercial from '../assets/services/servicio-comercial-373x200.png';
import servicioDVR from '../assets/services/servicio-dvr-373x200.png';
import servicioGPS from '../assets/services/servicio-gps-373x200.png';

const Services = () => {
  const services = [
    {
      id: 1,
      title: 'Instalación de Cámaras HD',
      description: 'Instalación profesional de sistemas de videovigilancia con cámaras de alta definición. Incluye configuración completa, asesoría técnica y garantía en el servicio.',
      features: [
        'Cámaras de alta resolución',
        'Visión nocturna',
        'Instalación profesional',
        'Configuración remota',
      ],
    },
    {
      id: 2,
      title: 'Renta Mensual desde $400',
      description: 'Servicio de renta de equipos de seguridad sin inversión inicial. Planes flexibles adaptados a tu presupuesto con mantenimiento incluido.',
      features: [
        'Sin pago inicial',
        'Mantenimiento incluido',
        'Planes flexibles',
        'Equipos modernos',
      ],
    },
    {
      id: 3,
      title: 'Mantenimiento y Soporte Técnico',
      description: 'Servicio de mantenimiento preventivo y correctivo para garantizar el funcionamiento óptimo de tus sistemas de seguridad.',
      features: [
        'Mantenimiento preventivo',
        'Soporte técnico especializado',
        'Reparaciones rápidas',
        'Actualizaciones de software',
      ],
    },
    {
      id: 4,
      title: 'GPS y Cámaras para Vehículos',
      description: 'Sistema completo de rastreo GPS y videovigilancia para unidades móviles. Monitoreo en tiempo real y grabación continua.',
      features: [
        'Instalación: $1,200',
        'Renta desde $250/mes',
        'Rastreo en tiempo real',
        'Alertas y reportes',
      ],
    },
    {
      id: 5,
      title: 'Reparación de Sistemas y DVR',
      description: 'Diagnóstico y reparación especializada de equipos de videovigilancia, DVR, NVR y sistemas de seguridad de todas las marcas.',
      features: [
        'Diagnóstico gratuito',
        'Reparación certificada',
        'Todas las marcas',
        'Garantía en reparaciones',
      ],
    },
    {
      id: 6,
      title: 'Reparación de Equipo Especializado',
      description: 'Servicio de reparación de equipo especializado para patrullas y ambulancias. Soporte técnico profesional para unidades de emergencia.',
      features: [
        'Diagnóstico especializado',
        'Reparación de sistemas eléctricos y de comunicación',
        'Soporte para unidades de emergencia',
        'Garantía en reparaciones',
      ],
    },
  ];

  return (
    <div className="page">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">Nuestros Servicios</h1>
          <p className="page-subtitle">
            Soluciones completas de seguridad adaptadas a tus necesidades
          </p>
        </div>
      </section>

      <section className="services-section">
        <div className="container">
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <div className="service-icon">
                  {/* Icono aquí */}
                  <div className="icon-placeholder">
                    <span>📷</span>
                  </div>
                </div>

                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>

                <ul className="service-features">
                  {service.features.map((feature, index) => (
                    <li key={index}>
                      <span className="check-icon">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-images">
        <div className="container">
          <h2 className="section-title">Galería de Instalaciones</h2>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img
                src={servicioResidencial}
                alt="Instalación residencial de cámaras de seguridad HD - TecnoVigilancia 360"
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
              />
            </div>
            <div className="gallery-item">
              <img
                src={servicioComercial}
                alt="Instalación comercial de cámaras domo en negocio - TecnoVigilancia 360"
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
              />
            </div>
            <div className="gallery-item">
              <img
                src={servicioDVR}
                alt="Sistema DVR/NVR profesional con cableado estructurado - TecnoVigilancia 360"
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
              />
            </div>
            <div className="gallery-item">
              <img
                src={servicioGPS}
                alt="Sistema GPS y cámara vehicular instalado en vehículo - TecnoVigilancia 360"
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">¿Interesado en algún servicio?</h2>
          <p className="cta-text">
            Contáctanos para recibir una cotización personalizada sin compromiso
          </p>
          <Link to="/contact" className="btn btn-cta">
            Solicitar Cotización
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
